// extracted by mini-css-extract-plugin
module.exports = {"filter":"ClientsFilter_filter__2ArgX","header":"ClientsFilter_header__1ylTA","clearButton":"ClientsFilter_clearButton__2YwWp"};